module.exports = __webpack_public_path__ + "static/img/yytx27.2e7bd5e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/yytx27.png
// module id = 806
// module chunks = 0